import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { getFormApi } from 'src/app/dataObject/GetFormApi';
import { GetSalesForm } from 'src/app/dataObject/GetSalesForm';
import { ListCustomer } from 'src/app/dataObject/ListCustomer';
import { HelpService } from 'src/app/help-service';

@Component({
  selector: 'app-register-sales',
  templateUrl: './register-sales.component.html',
  styleUrls: ['./register-sales.component.css']
})
export class RegisterSalesComponent implements OnInit {

  public searchResult: any[];
  public searchResultBillTo: Array<ListCustomer> = [];
  public searchInputSoldTo: String = '';
  public searchInputBillTo: String = '';
  nameSoldTo: string;
  idSoldTo: string;
  selectedListCustomer: ListCustomer;
  selectedListCustomerBillTo: any;
  searchListCustomerBillTo: any[];
  searchResultBillToPage: any;
  page=1;
  maxData: number = 5;
  maxPage: number;
  dataCount: number;
  index=0;
  masterSelected:boolean;
  checkedList:any;
  showForm:boolean;
  showWarning:boolean;
  textWarning:string="";
  


  constructor(private helpService: HelpService, public fb: FormBuilder, private toastr: ToastrService,
    private route: ActivatedRoute,private router:Router) { }

  registerForm = this.fb.group({
    idRequest: ['', Validators.required],
    picName: ['', Validators.required],
    emailCustomer: ['', [Validators.required, Validators.email]],
    outletName: ['', Validators.required],
    emailSales: ['', Validators.required],
    billTo: ['', Validators.required],
    billToName: ['', Validators.required],
    soldToName: ['', Validators.required],
    address: ['', Validators.required],
    shipTo: ['', Validators.required],
  });

  getFormApi: getFormApi;
  getSalesForm: GetSalesForm;
  newCustList: any;

  ngOnInit(): void {
    const id: string = this.route.snapshot.queryParamMap.get('id');
    console.log(id);
    this.helpService.getCustomerReq(id)
      .subscribe(value => {
        this.getSalesForm = value.dataObject;
        console.log(this.getSalesForm);
        this.getFormApi=value;
        if(this.getFormApi.status === 1){
          this.showForm=true;
          this.showWarning=false;
          this.registerForm.patchValue({
            idRequest: this.getSalesForm.idRequest,
            picName: this.getSalesForm.picName,
            emailCustomer: this.getSalesForm.picEmail,
            emailSales: this.getSalesForm.emailSalesman,
            outletName: this.getSalesForm.outletName
          })
        }else{
          this.textWarning = this.getFormApi.message;
          this.showForm=false;
          this.showWarning=true;
        }
        
      })
  }

  get f() {
    return this.registerForm.controls;
  }

  searchByShipto(value) {
    console.log(value);
    let shipTo = value.target.value
    console.log(shipTo);
    if (shipTo === '') {
      console.log('tes')
      return this.searchResult = [];
    }
    this.helpService.getCustomerShipTo(shipTo)
      .subscribe(datax => {
        console.log(datax)
        this.searchResult = datax.dataObject;
        console.log(this.searchResult);
      }, (error) => {
        console.log(error);
      });

  }

  selectCustSoldTo(e) {
    console.log(e)
    var result = e.split('-');
    console.log(result);
    this.nameSoldTo = result[1].trim();
    this.idSoldTo = result[0].trim();
  }

  onShiptoChanged(searchInputSoldTo) {
    console.log('selected items : ', searchInputSoldTo)
    this.selectedListCustomer =this.searchResult.find((user) => user.shipTo.includes(searchInputSoldTo));

    this.registerForm.patchValue(
      {
        billToName: this.selectedListCustomer.billToName,
        soldToName: this.selectedListCustomer.shipToName,
        address: this.selectedListCustomer.address
      })
  }

  searchByBillto(value) {
    console.log(value);
    let billTo = value.target.value
    console.log(billTo);
    if (billTo === '') {
      console.log('tes')
      this.dataCount = 0;
      return this.searchListCustomerBillTo = [];

    }
    this.helpService.searchBillTo(billTo)
      .subscribe(datax => {
        console.log(datax)
        this.searchListCustomerBillTo = datax.dataObject;
        console.log(this.searchListCustomerBillTo);
      }, (error) => {
        console.log(error);
      });

  }

  onBilltoChanged(searchInputBillTo) {
    console.log('selected items : ', searchInputBillTo)
    this.selectedListCustomerBillTo = this.searchListCustomerBillTo.find((user) => user.id.includes(searchInputBillTo));
    if (this.selectedListCustomerBillTo === ''||this.selectedListCustomerBillTo==undefined) {
      this.dataCount = 0;
    } else {
      console.log(this.selectedListCustomerBillTo);
      this.registerForm.patchValue({
        billTo: this.selectedListCustomerBillTo.id,
        billToName: this.selectedListCustomerBillTo.name
      });
     
      this.helpService.getCustomerBillTo(searchInputBillTo)
        .subscribe(datax => {
          console.log(datax)
          this.searchResultBillTo = datax.dataObject;
          console.log(this.dataCount);
          this.searchResultBillToPage = this.searchResultBillTo;
        }, (error) => {
          console.log(error);
        })
    }

    // this.registerForm.patchValue(
    //   {
    //     billToName:this.selectedListCustomer.billToName,
    //     soldToName:this.selectedListCustomer.shipToName,
    //     address:this.selectedListCustomer.address
    //   })
  }

  checkUncheckAll() {
    for (var i = 0; i < this.searchResultBillToPage.length; i++) {
      this.searchResultBillToPage[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  isAllSelected() {
    this.masterSelected = this.searchResultBillToPage.every(function(item:any) {
        return item.isSelected == true;
      })
    this.getCheckedItemList();
  }

  getCheckedItemList(){
    this.checkedList = [];
    for (var i = 0; i < this.searchResultBillToPage.length; i++) {
      if(this.searchResultBillToPage[i].isSelected)
      this.checkedList.push(this.searchResultBillToPage[i].shipTo);
    }
    // this.checkedList = JSON.stringify(this.checkedList);
     console.log(this.checkedList);
  }

  submitForm() {
    this.checkedList = [];
    this.checkedList.push(this.registerForm.get('shipTo').value);
    //this.checkedList = JSON.stringify(this.checkedList);
    console.log(this.registerForm.value);
    console.log(this.checkedList);
    this.submitFormBillTo()
    
  }

  submitFormBillTo() {
    console.log(this.registerForm.value);
    console.log(this.checkedList);
    const stringShipto = this.checkedList.toString();
    console.log(stringShipto);
    this.helpService.saveSalesForm(this.registerForm.value,stringShipto)
    .subscribe(data=>{
      this.getFormApi=data;
      if (this.getFormApi.status === 1) {
        // this.notify.showSuccess(this.getFormApi.message, "Success");
         alert(this.getFormApi.message)
         console.log(this.getFormApi.message);
         this.router.navigate(['']);
       } else {
         //this.notify.showError(this.getFormApi.message, "Error!!");
         alert(this.getFormApi.message)
         console.log(this.getFormApi.message);
       }

    },error=>{
      console.log(error)
    })
  }

}
